<template>
<div v-if="showEvidenceDialog">
    <el-dialog :visible.sync="showEvidenceDialog" width="300" title="上传证据" :before-close="handleClose" :destroy-on-close="true" :close-on-click-modal="false" center>
        <el-form :model="uploadForm" :rules="rulesupload" ref="uploadForm" label-width="150px" class="demo-ruleForm" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-form-item label="上传栏目" prop="categorySmall" v-if="isStaff">
                <el-select v-model="uploadForm.categorySmall" placeholder="请选择">
                    <el-option v-for="item in uploadSectionOptions" :key="item.type" :label="item.name" :value="item.type">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--prop="categoryMiddle"-->
            <el-form-item label="当事人名称" v-if="isStaff">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleLitigantCheckAllChange">全部</el-checkbox>
                <el-checkbox-group v-model="uploadForm.categoryMiddle" @change="handleCheckedLitigantChange">
                    <el-checkbox v-for="(item, index) in litigants" :label="index" :key="index">{{item.personName}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="证据名称" prop="remark">
                <el-input v-model="uploadForm.remark"></el-input>
            </el-form-item>
            <el-form-item label="证明对象" prop="objectProof">
                <el-input v-model="uploadForm.objectProof" type="textarea" :rows="2" maxlength="200" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="证据附件" prop="files">
                <el-upload class="upload-demo"  multiple
                :on-change="handleChange" :action="actionUrl" :data="uploaddata" :accept="acceptType" :headers="flk" :on-success="successother" :on-remove="fileremove" :before-upload="handleBefore" :on-exceed="handleExceed">
                    <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                    <span class="el-upload__tip " style="margin-left: 20px">只能上传pdf/doc/docx/png/jpg/xls/xlsx文件，{{maxFileTip}}</span>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="uploadEvidence">确 定</el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
// import { loginOut } from '@/api/login.js'
import AlertEmit from '@/views/caseSpace/components/alertEmit.js'
import {
    saveAttachmentUpload
} from '@/api/user.js'
import {
    getStore, maxFileLength, maxFileWarning, maxFileTip} from '@/utils/utils.js'
import {
    searchDictionaryInfo,
    searchBizUserRole,
    getMeetingPersonList
} from '@/api/common.js'
import config from '@/config/config.js'
import {
    setTimeout, clearInterval
} from 'timers';
// import { getMediationRoomUserInfoList } from "@/api/casespace.js";
export default {
    props: ['ws', 'currentRoomId', 'showEvidenceDialog'],
    data() {
        return {
            isIndeterminate: false,
            checkAll: true,
            maxFileTip: maxFileTip,
            // 所有当事人集合
            allLitigants: {},
            litigants: [],
            uploaddata: {
                isView: 'VIEW'
            },
            actionUrl: config.baseURL + '/gzzc/docBook/upload',
            acceptType: '.pdf,.doc,.docx,.png,.jpg,.xls,.xlsx',
            flk: {
                JWTToken: '',
                appName: config.appName,
                cType: 'PC'
            },
            // 上传栏目可选数组
            uploadSectionOptions: [
                {name : '办案人员', type: 'MEDIATOR'},
                {name : '申请人', type: 'APPLICANT'},
                {name : '被申请人', type: 'RESPONDENT'}
            ],
            uploadForm: {
                typeoptions: [],
                categorySmall: '',
                nameoptions: [],
                remark: '',
                categoryMiddle: [],
                files: [],
                objectProof: '',
            },
            rulesupload: {
                categorySmall: [{
                    required: true,
                    message: '请选择上传栏目',
                    trigger: 'change'
                }],
                categoryMiddle: [{
                    required: true,
                    message: '请勾选当事人名称',
                    trigger: 'change'
                }],
                remark: [{
                    required: true,
                    message: '请输入材料名称',
                    trigger: 'blur'
                }],
                objectProof: [{
                    required: true,
                    message: '请输入证明对象',
                    trigger: 'blur'
                }],
                files: [{
                    required: false,
                    message: '请上传证据附件',
                    trigger: 'blur'
                }]

            },
            dataChatMainWS: '', //案件空间上传文件使用
            isStaff: false,
            loading: false,
        }
    },
    watch: {
        'uploadForm.categorySmall' (value) {
            if (value === 'APPLICANT') {
                this.litigants = this.allLitigants.applicantList
            } else if (value === 'RESPONDENT') {
                this.litigants = this.allLitigants.respondentList
            } else if (value === 'MEDIATOR') {
                this.litigants = this.allLitigants.mediatorList
            }  else {
                this.litigants = []
            }
            if (this.isStaff) {
                let indexs = []
                this.litigants.map((_, index) => {
                    indexs.push(index)
                })
                this.uploadForm.categoryMiddle = indexs
            } else {
                let loginInfo = JSON.parse(getStore('loginInfo'))
                this.uploadForm.categoryMiddle = [0]
                this.litigants = [{userId: loginInfo.memberId, personName: loginInfo.memberName}]
                console.log(this.litigants)
            }
        },
        showEvidenceDialog (value) {
            // 每次打开都刷新
            if (value) {
                this.initData()
            }
        }
    },
    mounted() {
        let loginInfo = JSON.parse(getStore('loginInfo'))
        console.log(loginInfo)
        let personType = loginInfo.hasOwnProperty('personType') ? loginInfo.personType : ''
        if (personType !== 'STAFF') {
            this.isStaff = false
            console.log('获取调解室用户信息列表///')
            this.uploadForm.categorySmall = this.$route.query.memberType
        } else {
            this.isStaff = true
        }
    },
    methods: {
        handleLitigantCheckAllChange(val) {
            console.log(val)
            let indexs = []
            this.litigants.map((_, index) => {
                indexs.push(index)
            })
            this.uploadForm.categoryMiddle = val ? indexs : []
            this.isIndeterminate = false
        },
        handleCheckedLitigantChange(value) {
            console.log(value)
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.litigants.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.litigants.length;
        },
        handleClose() {
            console.log('取消====', this.showEvidenceDialog)
            this.$emit('handleClose', this.showEvidenceDialog)
            // this.showEvidenceDialog = false
            // console.log('handleClose');
            if (this.isStaff) {
                this.uploadForm.categorySmall = ''
            }
            this.uploadForm.remark = ''
            this.uploadForm.files = []
            this.uploadForm.objectProof = ''
        },
        handleExceed() {
            // this.$message.info('最多上传一个文件')
        },
        successother(res, file) {
            if (res.code === 1000) {
                this.uploadForm.files.push({
                    "fileId": res.data.fileId,
                    "fileName": file.name
                })
                this.$refs.uploadForm.validateField('files');
                this.dataChatMainWS = {
                    data: res.data,
                    file: file
                }
            }
        },

        fileremove(file,fileList) {
            this.uploadForm.files = []
            for(let item in fileList){
                this.uploadForm.files.push({
                    "fileId": fileList[item].response.data.fileId,
                    "fileName": fileList[item].name
                })
            }
            this.$refs.uploadForm.validateField('files');
        },
        handleBefore(file) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            this.flk.JWTToken = getStore('flk');
            let isAcceptType = true
            let tempRet = /\.[^.]+$/.exec(file.name)
            if (tempRet) {
                if (!~this.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType)
                this.$message.error('文件只支持' + this.acceptType + '等格式');

            return isAcceptType;

        },
        handleChange(file, fileList) {
            //   if (file.size > 1024 * 5 * 1024) {
            //     this.$message({
            //       type: 'warning',
            //       message: '文件大小不能超过5M'
            //     });
            //     return false
            //   }
            //   let tempRet = /\.[^.]+$/.exec(file.name)
            //   let isAcceptType = true
            //   if (tempRet) {
            //     if (!~this.acceptType.indexOf(tempRet[0])) {
            //       isAcceptType = false
            //     }
            //   }
            //   if (!isAcceptType) {
            //     this.$message({
            //       type: 'warning',
            //       message: '文件只支持' + this.acceptType + '等格式'
            //     });
            //     fileList.pop()
            //     return
            //   }
            // if (tempRet.index > 20) {
            //   this.$message({
            //     type: 'warning',
            //     message: '文件名不超过20个字符长度'
            //   })
            //   return false
            // }
        },
        // 初始化数据
        initData() {
            this.loading = true
            let parmas = {meetingId : this.$route.query.meetingid}
            getMeetingPersonList(parmas).then(res => {
                this.loading = false
                console.log(res)
                if (res.data.code == 1000) {
                    this.allLitigants = res.data.data
                }
            }, erro => {
                this.loading = false
            })
            // searchBizUserRole({}).then(res => {
            //     if (res.data.code == 1000) {
            //         this.uploadForm.typeroleoptions = res.data.data
            //     }
            // }, erro => {})
            // searchDictionaryInfo({
            //     parentCode: 'zcAttachmentList'
            // }).then(res => {
            //     if (res.data.code == 1000) {
            //         this.uploadForm.typeoptions = res.data.data.sort(function (a, b) {
            //             return a.code.substr(-1) - b.code.substr(-1)
            //         });
            //     }
            // })
        },
        uploadEvidence(formName) {
            this.$refs.uploadForm.validate((valid) => {
                if (valid) {
                    if(this.uploadForm.remark.indexOf('&') != -1 || this.uploadForm.remark.indexOf('#') != -1 || this.uploadForm.remark.indexOf('$') != -1){
                         this.$message({
                            type: 'error',
                            message: '证据名称含有特殊符号'
                         })
                         return
                    }
                    if(this.uploadForm.objectProof.indexOf('&') != -1 || this.uploadForm.objectProof.indexOf('#') != -1 || this.uploadForm.objectProof.indexOf('$') != -1){
                         this.$message({
                            type: 'error',
                            message: '证据对象含有特殊符号'
                         })
                         return
                    }
                    let userIds = []
                    let userNames = []
                    this.uploadForm.categoryMiddle.map(index => {
                        let item = this.litigants[index]
                        userIds.push(item.userId)
                        userNames.push(item.personName)
                    })
                    userNames = userNames.toString()
                    userIds = userIds.toString()
                    let files = []
                    let fileList = this.uploadForm.files
                    for (let index = 0; index < fileList.length; index++) {
                        let item = fileList[index]
                        let obj = Object.assign({}, item, {
                            "categoryMiddle": userNames
                        })
                        files.push(obj)
                    }
                    // let name = files[0].fileName
                    // if(name.substring(name.length-3) =='exe') {
                    //     this.$message({
                    //         type: 'error',
                    //         message: '不能上传exe文件，请重新上传'
                    //     })
                    //     return
                    // }
                    let params = {
                        "caseId": this.$route.query.caseid,
                        "categoryMiddle": userIds, //当事人名称ids
                        "sign": userNames, //当事人名称names
                        "categorySmall": this.uploadForm.categorySmall, //上传栏目
                        files,
                        "meetingId": this.$route.query.meetingid, // 调解室（会议）里面
                        "objectProof": this.uploadForm.objectProof, //证明对象
                        "remark": this.uploadForm.remark
                    }
                    saveAttachmentUpload(params).then(res => {
                        if (res.data.code === 1000) {
                            let resData = res.data.data
                            this.$message.success('上传成功')

                            AlertEmit.$emit('getList', true)
                            // this.$emit('handleClose')
                            // this.showEvidenceDialog = false
                            this.$parent.showEvidenceDialog = false
                            if (this.ws) { //多个地方调用此组件判断有无传参进行调用
                                this.handleChatMainWS(this.uploadForm)
                            }
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => {
                        console.log('dodong----',err)
                        this.$message({
                            type: 'error',
                            message: err
                        })
                    }).finally(() => {
                        this.handleClose()
                    })
                } else {
                    console.log(this.uploadForm)
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleChatMainWS(obj) {

            //视频内调用上传发送ws
            let file = this.dataChatMainWS.file
            let type = 'OTHER'
            if(file){
               type = this.getFileType(file.name.split('.').reverse()[0])
            }
            let fileId = ''
            let filePath = ''
            if(this.dataChatMainWS && this.dataChatMainWS.data && this.dataChatMainWS.data.fileId){
              fileId = this.dataChatMainWS.data.fileId
            }
             if(this.dataChatMainWS && this.dataChatMainWS.data && this.dataChatMainWS.data.previewUrl){
              filePath = this.dataChatMainWS.data.previewUrl
            }
            let data = {
                roomId: this.currentRoomId,
                messageType: 'EVIDENCE',
                messageResource: 'HANDLER_INPUT',
                content: JSON.stringify([{
                    fileId: fileId,
                    fileName: obj.files.length ? obj.files[0].fileName : '',
                    edvName: this.uploadForm.remark,
                    filePath: filePath,
                    categoryBig: type
                }])
            }
            let msgdata = {};
            msgdata.event = "SEND_MESSAGE";
            msgdata.data = data;
            this.ws.send(JSON.stringify(msgdata))
        },
        getFileType(type) {
            //VOICE,VIDEO,IMG,OTHER;
            type = type.toLowerCase();
            if (type === 'mp3' || type === 'wav') {
                return 'VOICE'
            } else if (type === 'mp4' || type === 'wav' || type === 'ogg') {
                return 'VIDEO'
            } else if (type === 'jpg' || type === 'png' || type === 'gif' || type === 'jpeg') {
                return 'IMG'
            } else {
                return 'OTHER'
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
    padding-bottom: 20px;

    .el-button {
        width: 120px;
        height: 40px;
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
